/**
 * Card pictures, without storing a single pixel.
 *
 * The collection rows already carry the Scryfall printing id, which addresses
 * the image API directly. When the catalog never knew the printing (or the id
 * is missing), the set code and collector number printed on the card resolve
 * the same picture through Scryfall's card resolver - the same fallback the
 * hover preview in the old toolkit used when the CDN missed.
 */

export type ScryfallImageVersion = 'small' | 'normal' | 'large';

export interface CardImageRef {
  scryfallId: string | null;
  setCode: string;
  collectorNumber: string;
}

/** The direct image, or null when nothing on the row can address one. */
export function scryfallImageUrl(ref: CardImageRef, version: ScryfallImageVersion = 'normal'): string | null {
  if (ref.scryfallId !== null && ref.scryfallId !== '') {
    return `https://api.scryfall.com/cards/${ref.scryfallId}?format=image&version=${version}`;
  }
  return scryfallFallbackUrl(ref, version);
}

/** The set/collector resolver: what the direct image falls back to on error. */
export function scryfallFallbackUrl(ref: CardImageRef, version: ScryfallImageVersion = 'normal'): string | null {
  if (ref.setCode === '' || ref.collectorNumber === '') return null;
  return `https://api.scryfall.com/cards/${ref.setCode.toLowerCase()}/${ref.collectorNumber.toLowerCase()}?format=image&version=${version}`;
}
